import { X } from "lucide-react";

/**
 * Modal centrado reutilizable por la página de Facturación.
 *
 * Se renderiza por encima de la app con un overlay negro semitransparente.
 * El click fuera (`onClick={onClose}`) cierra; el click dentro del card no
 * propaga gracias a `stopPropagation`.
 *
 * Props:
 *  - children: contenido del modal.
 *  - onClose: callback de cierre (X o backdrop).
 *  - title: título mostrado en la cabecera.
 *  - wide: si true usa max-w-2xl en lugar de max-w-sm.
 *
 * Extraído de `pages/Billing.jsx` en el refactor preventivo de iteración 66.
 */
export default function Dialog({ children, onClose, title, wide, size }) {
  // Iter 107 — Soporte para tamaño "xl" (usado por el modal de facturas pendientes)
  const widthClass =
    size === "xl" ? "max-w-6xl"
    : wide ? "max-w-2xl"
    : "max-w-sm";
  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4" onClick={onClose}>
      <div className={`bg-white border border-[#111110] shadow-hard w-full ${widthClass}`} onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between px-4 py-3 border-b border-[#E5E5E0]">
          <div className="font-display font-bold text-sm">{title}</div>
          <button onClick={onClose} className="p-1 hover:bg-[#F7F7F4]"><X size={14} /></button>
        </div>
        <div className="p-4">{children}</div>
      </div>
    </div>
  );
}
